import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select'; // <--- This is the correct import for react-select's Select component
import FormInput from '../../form/FormInput';
import FormSelect from '../../form/FormSelect';
import FormDatePicker from '../../form/FormDatePicker';
import CDProfileImageUpload from './CDProfileImageUpload';
import { genericSelectStyles } from '../../../utils/formConstants'; // Use generic styles here directly for Select
import { Controller } from 'react-hook-form';

const StepCompanyInfo = ({ 
    control, errors, lookupOptions, 
    profileImagePreview, handleImageChange, 
    isWhatsappSame, handleWhatsappCheck,
    isPanRequired, isAadharRequired
}) => (
    <div className="animate-fade-in">
        <Row>
            <CDProfileImageUpload profileImagePreview={profileImagePreview} handleImageChange={handleImageChange} />
            <Col md={9}>
                <div className="form-section-title mt-0">Agency Details</div>
                <Row>
                    <Col md={4}><FormInput name="yourName" label="Full Name" control={control} errors={errors} readOnly isRequired /></Col>
                    <Col md={4}><FormInput name="agencyName" label="Agency Name" control={control} errors={errors} isRequired /></Col>
                    <Col md={4}><FormInput name="email" label="Email" type="email" control={control} errors={errors} readOnly isRequired /></Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <FormInput name="mobileNumber" label="Mobile" control={control} errors={errors} readOnly isRequired />
                        <Form.Check type="checkbox" label="Use same for WhatsApp?" className="text-white small mt-1" checked={isWhatsappSame} onChange={handleWhatsappCheck} />
                    </Col>
                    <Col md={4}><FormInput name="website" label="Website URL" control={control} errors={errors} /></Col>
                    <Col md={4}><FormDatePicker name="companyIncorporationDate" label="Incorporation Date" control={control} errors={errors} isRequired /></Col>
                </Row>
                <Row>
                    <Col md={4}><FormInput name="alternateMobileNumber" label="Alt Mobile" control={control} errors={errors} /></Col>
                    <Col md={4}><FormSelect name="countryOfResidence" label="Country" control={control} errors={errors} options={lookupOptions.countryOfResidence} isRequired /></Col>
                    <Col md={4}> {/* Custom Select for Specialization, using generic styles */}
                        <Form.Group className="mb-4">
                            <Form.Label className="form-label">Specialization <span className="text-danger">*</span></Form.Label>
                            <Controller name="specialization" control={control} render={({ field }) => (
                                <Select {...field} isMulti options={lookupOptions.specialization} styles={genericSelectStyles} placeholder="Select Specializations" />
                            )} />
                            {errors.specialization && <div className="text-danger small mt-1">{errors.specialization.message}</div>}
                        </Form.Group>
                    </Col>
                </Row>
                <div className="form-section-title">Legal Identity</div>
                <Row>
                    <Col md={4}><FormInput name="panNumber" label="PAN Card" control={control} errors={errors} isRequired={isPanRequired} /></Col>
                    <Col md={4}><FormInput name="aadharNumber" label="Aadhar Number" control={control} errors={errors} isRequired={isAadharRequired} /></Col>
                    <Col md={4}><FormInput name="gstNumber" label="GST Number (Optional)" control={control} errors={errors} /></Col>
                </Row>
                <div className="form-section-title">About Agency</div>
                <Row><Col md={12}><FormInput name="aboutAgency" label="Description" control={control} errors={errors} as="textarea" isRequired /></Col></Row>
            </Col>
        </Row>
    </div>
);

export default StepCompanyInfo;